import { ShowroomCardContainer } from '@makemydeal/dr-sales-checkin-components';
import SciFinancingCustomerCard from './SciFinancingCustomerCard';

const Financing = () => (
    <ShowroomCardContainer>
        <SciFinancingCustomerCard />
    </ShowroomCardContainer>
);

export default Financing;
